document.addEventListener("DOMContentLoaded", () => {
  const slides = document.querySelectorAll("slideshow-slide");

  slides.forEach((slide) => {
    const imageContainer = slide.querySelector(".slide__image-container");

    // Skip slides without sound controls
    if (!imageContainer || !imageContainer.classList.contains("has_sound_controls")) return;

    const video = imageContainer.querySelector("video");
    if (!video) return;

    const soundBtn = slide.querySelector(".sound-control-btn");

    // 🔁 Define toggle function (used by both slide & button)
    const toggleVideoSound = () => {
      if (video.muted) {
        // Mute all other videos
        document.querySelectorAll("video").forEach((v) => {
          v.muted = true;
          v.closest("slideshow-slide")?.classList.remove("video-sound-on");
          v.closest("slideshow-slide")?.classList.add("video-sound-off");
        });

        // Unmute this video
        video.muted = false;
        slide.classList.add("video-sound-on");
        slide.classList.remove("video-sound-off");
        console.log("[SoundControl] 🔊 Unmuted:", video);
      } else {
        // Mute this video
        video.muted = true;
        slide.classList.add("video-sound-off");
        slide.classList.remove("video-sound-on");
        console.log("[SoundControl] 🔇 Muted:", video);
      }
    };

    // 🎬 Click on entire slide
    slide.addEventListener("click", (e) => {
      // Avoid double-trigger if sound button is clicked
      if (e.target.closest(".sound-control-btn")) return;
      toggleVideoSound();
    });

    // 🔊 Click on sound control button
    if (soundBtn) {
      soundBtn.addEventListener("click", (e) => {
        e.stopPropagation(); // prevent slide click duplication
        toggleVideoSound();
      });
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const detailBlocks = document.querySelectorAll(".details-content");

  detailBlocks.forEach((block) => {
    const mediaContainer = block.querySelector(".details-content-image");

    // Skip if no media or no sound controls
    if (!mediaContainer || !mediaContainer.classList.contains("has_sound_controls")) return;

    const video = mediaContainer.querySelector("video");
    if (!video) return;

    const soundBtn = block.querySelector(".sound-control-btn");

    // 🔁 Reusable toggle function
    const toggleVideoSound = () => {
      if (video.muted) {
        // Mute all videos across the section
        document.querySelectorAll(".details-content-image video").forEach((v) => {
          v.muted = true;
          v.closest(".details-content-image")?.classList.remove("video-sound-on");
          v.closest(".details-content-image")?.classList.add("video-sound-off");
        });

        // Unmute current video
        video.muted = false;
        mediaContainer.classList.add("video-sound-on");
        mediaContainer.classList.remove("video-sound-off");
        console.log("[DetailsSound] 🔊 Unmuted");
      } else {
        // Mute current
        video.muted = true;
        mediaContainer.classList.add("video-sound-off");
        mediaContainer.classList.remove("video-sound-on");
        console.log("[DetailsSound] 🔇 Muted");
      }
    };

    // 🎬 Click on the whole media container
    mediaContainer.addEventListener("click", (e) => {
      // Avoid double toggle when clicking on button
      if (e.target.closest(".sound-control-btn")) return;
      toggleVideoSound();
    });

    // 🔊 Click on sound control button
    if (soundBtn) {
      soundBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        toggleVideoSound();
      });
    }
  });
});


//Mega menu --menu image
// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelectorAll('.mega-menu-image-block').forEach(function (block) {
//     // Normalize the link-title: trim + collapse spaces + lowercase
//     const parentTitle = block
//       .getAttribute('link-title')
//       ?.replace(/\s+/g, ' ')
//       .trim()
//       .toLowerCase();

//     if (!parentTitle) return;
//     console.log("Parent title:", parentTitle);

//     block.querySelectorAll('.menu-image-wrap[block-link-title]').forEach(function (imageBlock) {
//       // Normalize the block-link-title the same way
//       const linkTitle = imageBlock
//         .getAttribute('block-link-title')
//         ?.replace(/\s+/g, ' ')
//         .trim()
//         .toLowerCase();

//       console.log("Link title:", linkTitle);

//       // Remove non-matching image blocks
//       if (linkTitle !== parentTitle) {
//         console.log("Removing non-matching image:", imageBlock);
//         imageBlock.remove();
//         imageBlock.classList.add('hidden')
//       } else {
//         console.log("Keeping matching image:", imageBlock);
//       }
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  // Function to clean menu images
  function cleanMenuImages() {
    const uls = document.querySelectorAll("ul[data-menu-list-id]");

    uls.forEach((ul) => {
      const ulTitle = ul.getAttribute("link-title");
      const imageWraps = ul.querySelectorAll(".menu-image-wrap");

      imageWraps.forEach((div) => {
        const divTitle = div.getAttribute("block-link-title");
        if (divTitle !== ulTitle) {
          div.remove();
        }
      });
    });
  }

  // Run function on hover of menu links
  const menuLinks = document.querySelectorAll(".menu-list__link");

  menuLinks.forEach((link) => {
    link.addEventListener("mouseenter", cleanMenuImages);
  });
});


//Cart quntity drawer
//Cart quntity drawer
// Track bound wrappers to prevent double-binding
const boundWrappers = new WeakSet();

function initCustomQuantityDropdowns() {
  document
    .querySelectorAll(".custom-quantity-input-wrapper")
    .forEach((wrapper) => {
      // Skip if already bound
      if (boundWrappers.has(wrapper)) return;

      const caretBtn = wrapper.querySelector(".custom-quantity-caret");
      const drawer = wrapper.querySelector(".custom-quantity-drawer");
      const input = wrapper.querySelector('input[type="number"]');

      if (!caretBtn || !drawer || !input) return;

      // Mark as bound
      boundWrappers.add(wrapper);

      caretBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        drawer.classList.toggle("hidden");
      });

      drawer.querySelectorAll("li").forEach((item) => {
        item.addEventListener("click", () => {
          if (input instanceof HTMLInputElement && item.dataset.value) {
            input.value = parseInt(item.dataset.value, 10).toString();
            drawer.classList.add("hidden");

            input.dispatchEvent(new Event("blur", { bubbles: true }));
          }
        });
      });
    });
}

// Event delegation for closing drawers when clicking outside
// This is more efficient than adding a listener per wrapper
document.addEventListener("click", (e) => {
  if (!e.target || !(e.target instanceof Element)) return;

  const clickedWrapper = e.target.closest(".custom-quantity-input-wrapper");

  document.querySelectorAll(".custom-quantity-drawer").forEach((drawer) => {
    if (!(drawer instanceof HTMLElement)) return;
    const wrapper = drawer.closest(".custom-quantity-input-wrapper");
    // Close drawer if it's open and the click was outside its wrapper
    if (
      drawer &&
      !drawer.classList.contains("hidden") &&
      wrapper !== clickedWrapper
    ) {
      drawer.classList.add("hidden");
    }
  });
});

// Initial binding
document.addEventListener("DOMContentLoaded", initCustomQuantityDropdowns);

// Bind again when cart updates (with delay to ensure morphSection has completed)
// Using 'cart:update' which is ThemeEvents.cartUpdate
document.addEventListener("cart:update", () => {
  // Small delay to ensure DOM has been updated by morphSection
  setTimeout(() => {
    initCustomQuantityDropdowns();
  }, 0);
});

// Also listen for discount updates (which can affect cart items)
// Using 'discount:update' which is ThemeEvents.discountUpdate
document.addEventListener("discount:update", () => {
  setTimeout(() => {
    initCustomQuantityDropdowns();
  }, 0);
});





//Product Tab section

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".tab-btn");
  const panes = document.querySelectorAll(".tab-pane");

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      let tab = btn.dataset.tab;

      buttons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      panes.forEach((pane) => {
        pane.classList.remove("active");
        if (pane.id === tab) pane.classList.add("active");
      });
    });
  });
});